

export const HomeHeader = () => {
    return <img className="w-full" src="/homeBanner.png" alt="" />
}